module.exports = __webpack_public_path__ + "static/media/p7.36092134.jpeg";